import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import { Badge, TextTooltip } from "@transfr-inc/dashboard-components";

import "./ai-entry-card.scss";

export const AiEntryCard = ({
  image,
  title,
  description,
  buttonLabel,
  buttonIcon,
  disabled,
  comingSoon,
  loading,
  onClick,
}) => {
  const card = (
    <button
      type="button"
      className={clsx(
        "ai-entry-card",
        disabled && "ai-entry-card--disabled",
        loading && "ai-entry-card--loading"
      )}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      aria-disabled={disabled || loading}
    >
      <div className="ai-entry-card__illustration">
        {image && <img src={image} alt="" />}
      </div>
      <div className="ai-entry-card__title">
        {title}
        {comingSoon && (
          <Badge className="ai-entry-card__badge" value="Coming Soon" />
        )}
      </div>
      <div className="ai-entry-card__description">{description}</div>
      {buttonLabel && (
        <span className="ai-entry-card__action">
          {loading ? (
            <FontAwesomeIcon icon={["fa-regular", "rotate"]} spin />
          ) : (
            <>
              {buttonLabel}
              {buttonIcon && (
                <FontAwesomeIcon icon={["fa-regular", buttonIcon]} />
              )}
            </>
          )}
        </span>
      )}
    </button>
  );

  if (disabled && comingSoon) {
    return (
      <TextTooltip text="This entry point is coming soon.">{card}</TextTooltip>
    );
  }
  return card;
};
